import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import apiService from '../../services/apiService'

function PrivacyPolicyPage() {
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPrivacyPolicy = async () => {
      try {
        setLoading(true);
        const response = await apiService.get('/privacy-policy');
        setPolicy(response);
      } catch (err) {
        console.error('Fetch privacy policy error:', err);
        setError(err.response?.data?.error || 'Failed to load privacy policy');
        toast.error('Failed to load privacy policy');
      } finally {
        setLoading(false);
      }
    };

    fetchPrivacyPolicy();
  }, []);

  if (loading) {
    return <div className="text-center text-gray-600 dark:text-gray-300">Loading privacy policy...</div>;
  }

  if (error) {
    return <div className="text-center text-red-600 dark:text-red-400">Error: {error}</div>;
  }

  if (!policy) {
    return <div className="text-center text-gray-600 dark:text-gray-300">No privacy policy available.</div>;
  }

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md">
      <h1 className="text-3xl font-bold text-gray-800 dark:text-gray-100 mb-6">{policy.title}</h1>
      <div 
        className="prose dark:prose-invert max-w-none"
        dangerouslySetInnerHTML={{ __html: policy.content }}
      />
      <p className="mt-6 text-sm text-gray-500 dark:text-gray-400">
        Last updated: {new Date(policy.updatedAt).toLocaleDateString()}
      </p>
    </div>
  );
}

export default PrivacyPolicyPage;